export enum LightsSettingsSupportType {
	/**
	 * Light settings are not supported
	 */
	NotSupported = 'notSupported',

	/**
	 * Light settings (with image) are fully supported
	 */
	Supported = 'supported',

	/**
	 * Light settings are supported but without image
	 */
	SupportedWithoutImage = 'supportedWithoutImage',

	/**
	 * Light settings (with legacy image) are fully supported
	 */
	SupportedLegacy = 'supportedLegacy'
}

/**
 * `CoverageMapDeviceBehaviorPlugin` describes device specifics about a device
 * that supports being used in the coverage map feature.
 */
export interface LightsSettingsDeviceBehaviorPlugin {
	/**
	 * return a value indicating LightsSettings support for the device
	 */
	getLightsSettingsSupportType(virtual?: boolean): LightsSettingsSupportType;
}
